/**
 * Created by jerome on 13/10/2018.
 */
import LinkedList from '../data-structure/LinkedList'
import addProperty from '../func/addProperty'
import { requestAnimFrame, cancelAnimFrame } from '../func/requestAnimFrame'
export default function Animator () {
  const animations = new LinkedList()
  let requestUpdate = false
  let node = null
  let frameTime = 0
  addProperty(this, 'frameTime', function (value) {
  }, function () {
    return frameTime
  })
  let renderer = null
  addProperty(this, 'renderer', function (value) {
    renderer = value
  }, function () {
    return renderer
  })

  const onEnterFrame = function () {
    update()
    requestUpdate = false
    frameRequest = requestAnimFrame(onEnterFrame)
  }
  let frameRequest = requestAnimFrame(onEnterFrame)
  const update = function () {
    const start = Date.now()
    if (renderer !== null) renderer.startRender()
    node = animations.head
    while (node) {
      node.data.update(renderer ? renderer.ctx : null)
      node = node.next
    }
    if (renderer !== null) renderer.finishRender()
    frameTime = Date.now() - start
  }
  this.requestDraw = function () {
    requestUpdate = true
  }
  this.forceDraw = function () {
    requestUpdate = true
    draw()
  }
  this.addAnimation = function (animation) {
    animation.animator = this
    animation.node = animations.append(animation)
    return animation
  }
  this.dispose = function () {
    console.log('dispose')
    cancelAnimFrame(frameRequest)
    while (animation.head) {
      //TODO check si tout est ok
      animation.head.data.dispose()
    }
    draw()
  }
}